import axios from 'axios'

export default {
    getMemberReport(params){
        return axios.get('/report/member', {params})
            .then(response => {
                return response.data
            })
    },
    getNewComerReport(params){
        return axios.get('/report/newcomer', {params})
            .then(response => {
                return response.data
            })
    },
    getIkidReport(params){
        return axios.get('/report/ikid', {params})
            .then(response => {
                return response.data
            })
    },
    getICLReport(params){
        return axios.get('/report/icl', {params})
            .then(response => {
                return response.data
            })
    },
    getHODReport(params){
        return axios.get('/report/hod', {params})
            .then(response => {
                return response.data
            })
    },
    getIcareCoreTeamReport(params){
        return axios.get('/report/icarecoreteam', {params})
            .then(response => {
                return response.data
            })
    },
    getDepartmentCoreTeamReport(params){
        return axios.get('/report/departmentcoreteam', {params})
            .then(response => {
                return response.data
            })
    },
    getIcareMemberReport(params){
        return axios.get('/report/icaremember', {params})
            .then(response => {
                return response.data
            })
    },
    getIcareReport(params){
        return axios.get('/report/icare', {params})
            .then(response => {
                return response.data
            })
    },
    getIcareReportMonth(params){
        return axios.get('/report/icare/month', {params})
            .then(response => {
                return response.data
            })
    },
    getIcareReportMonthAttendance(params){
        return axios.get('/report/icare/month_attendance', {params})
            .then(response => {
                return response.data
            })
    },
    getIcareYouthReport(params){
        return axios.get('/report/icareyouth', {params})
            .then(response => {
                return response.data
            })
    },
    getEventReportAttendance(params){
        return axios.get('/report/event/attendance', {params})
            .then(response => {
                return response.data
            })
    },
    getIkidReportMonthAttendance(params){
        return axios.get('/report/ikid/month_attendance', {params})
            .then(response => {
                return response.data
            })
    },
}